module.exports = __webpack_public_path__ + "static/media/vf_wsneakers_core.53d9acdb.svg";